import React, { useEffect, useRef } from 'react';
import Img from 'gatsby-image';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';

import { FluidImage } from 'types';

import {
  MinersList,
  MinerWrapper,
  MinerImgWrapper,
  MinersWrapper,
  Title,
} from './styled';

interface Props {
  data: { image: FluidImage; name: string }[];
}

const Miners = ({ data }: Props) => {
  const ref = useRef<SwiperCore | null>(null);

  useEffect(() => {
    setTimeout(() => {
      ref.current?.slidePrev(0, false);
    }, 0);
  }, []);

  return (
    <MinersWrapper>
      <Title>Our miners</Title>

      <Swiper
        spaceBetween={10}
        slidesPerView="1"
        updateOnWindowResize
        preventInteractionOnTransition
        observer
        onSwiper={(s) => {
          ref.current = s;
        }}
        breakpoints={{
          320: {
            spaceBetween: 10,
            slidesPerView: 1,
          },
          600: {
            spaceBetween: 10,
            slidesPerView: 2,
          },
          768: {
            spaceBetween: 30,
            slidesPerView: 3,
          },
          868: {
            spaceBetween: 30,
            slidesPerView: 4,
          },
        }}
      >
        <MinersList>
          {data.map(({ image, name }) => {
            return (
              <SwiperSlide key={name} style={{ width: 'auto' }}>
                <MinerWrapper>
                  <MinerImgWrapper>
                    <Img
                      fluid={{ ...image.localFile.childImageSharp.fluid }}
                      alt={name}
                    />
                  </MinerImgWrapper>
                  <p>{name}</p>
                </MinerWrapper>
              </SwiperSlide>
            );
          })}
        </MinersList>
      </Swiper>
    </MinersWrapper>
  );
};

export default Miners;
